import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  kyc_loading: false,
  corporate_loading: false,
  corporate_post_loading: false,
  general_information_dropdowns: null,
  general_information_data: null,
  contact_information_dropdowns: null,
  contact_information_data: null,
  bank_information_dropdowns: null,
  bank_information_data: null,
  investment_information_dropdowns: null,
  investment_information_data: null,
  custodian_detail_dropdowns: null,
  custodian_detail_data: null,
  signature_card_dropdown_data: null,
  client_classification_dropdowns: null,
  client_classification_data: null,
  signature_card_data: null,
  signature_card_dropdown_data: null,
  text_self_certification_dropdowns: null,
  tax_self_certification_data: null,
  acc_operation_data: null,
  document_types: [],
  uploaded_documents: [],
  countries_dropdown: null,
  application_status: null,
  client_application_id: null,
  client_company_id: null,
  client_applicant_id: null,
  client_rejection_comments: null,
  isKyc: false,
};

export const corporateSlice = createSlice({
  name: 'corporate',
  initialState,
  reducers: {
    setKycLoading: (state, action) => {
      state.kyc_loading = action.payload;
    },
    setCorpLoading: (state, action) => {
      state.corporate_loading = action.payload;
    },
    setCorpPostLoading: (state, action) => {
      state.corporate_post_loading = action.payload;
    },
    setCorpGeneralInfoDropdowns: (state, action) => {
      state.general_information_dropdowns = action.payload;
    },
    setCorpGeneralInfoData: (state, action) => {
      state.general_information_data = action.payload;
    },
    setCorpContactInfoDropdowns: (state, action) => {
      state.contact_information_dropdowns = action.payload;
    },
    setCorpContactInfoData: (state, action) => {
      state.contact_information_data = action.payload;
    },
    setCorpBankInfoDropdowns: (state, action) => {
      state.bank_information_dropdowns = action.payload;
    },
    setCorpBankInfoData: (state, action) => {
      state.bank_information_data = action.payload;
    },
    setCorpInvestmentInfoDropdowns: (state, action) => {
      state.investment_information_dropdowns = action.payload;
    },
    setCorpInvestmentInfoData: (state, action) => {
      state.investment_information_data = action.payload;
    },
    setCorpCustodianDetailDropdowns: (state, action) => {
      state.custodian_detail_dropdowns = action.payload;
    },
    setSignatureCardDropdownData: (state, action) => {
      state.signature_card_dropdown_data = action.payload;
    },
    setCorpCustodianDetailData: (state, action) => {
      state.custodian_detail_data = action.payload;
    },
    setClientClassificationDropdowns: (state, action) => {
      state.client_classification_dropdowns = action.payload;
    },
    setClientClassificationData: (state, action) => {
      state.client_classification_data = action.payload;
    },
    setSignatureCardData: (state, action) => {
      state.signature_card_data = action.payload;
    },
    setSignatureCardDropdownData: (state, action) => {
      state.signature_card_dropdown_data = action.payload;
    },
    setTaxSelfCertificationDropdowns: (state, action) => {
      state.text_self_certification_dropdowns = action.payload;
    },
    setTaxSelfCertificationData: (state, action) => {
      state.tax_self_certification_data = action.payload;
    },
    setCorpAccOperationInfo: (state, action) => {
      state.acc_operation_data = action.payload;
    },
    setDocumentTypes: (state, action) => {
      state.document_types = action.payload;
    },
    setUploadedDocuments: (state, action) => {
      state.uploaded_documents = action.payload;
    },
    setCountriesDropdown: (state, action) => {
      state.countries_dropdown = action.payload;
    },
    setApplicationStatus: (state, action) => {
      state.application_status = action.payload;
    },
    setClientApplicationId: (state, action) => {
      state.client_application_id = action.payload;
    },
    setClientCompanyId: (state, action) => {
      state.client_company_id = action.payload;
    },
    setClientApplicantId: (state, action) => {
      state.client_applicant_id = action.payload;
    },
    setClientRejectionComments: (state, action) => {
      state.client_rejection_comments = action.payload;
    },
    setIsKyc: (state, action) => {
      state.isKyc = action.payload;
    },
  },
});

export const {
  setKycLoading,
  setCorpLoading,
  setCorpPostLoading,
  setCorpGeneralInfoDropdowns,
  setCorpGeneralInfoData,
  setCorpContactInfoDropdowns,
  setCorpContactInfoData,
  setCorpBankInfoDropdowns,
  setCorpBankInfoData,
  setCorpInvestmentInfoDropdowns,
  setCorpInvestmentInfoData,
  setCorpCustodianDetailDropdowns,
  setCorpCustodianDetailData,
  setClientClassificationDropdowns,
  setSignatureCardDropdownData,
  setClientClassificationData,
  setSignatureCardData,
  setTaxSelfCertificationDropdowns,
  setTaxSelfCertificationData,
  setCorpAccOperationInfo,
  setDocumentTypes,
  setUploadedDocuments,
  setCountriesDropdown,
  setApplicationStatus,
  setClientApplicationId,
  setClientCompanyId,
  setClientApplicantId,
  setClientRejectionComments,
  setIsKyc,
} = corporateSlice.actions;

export default corporateSlice.reducer;
